import Analysis from 'domain/entity/analysis';
import ReadAnalysisCriteria from 'use-case/analysis/read/readAnalysisCriteria';
import getGenericUseCase from 'use-case/genericUseCase';

const getReadAnalysisUseCase = getGenericUseCase<Analysis, ReadAnalysisCriteria>((client, criteria) => client(criteria));

export default getReadAnalysisUseCase;
